import { render, staticRenderFns } from "./ProjectBasicInformation.vue?vue&type=template&id=611891aa&"
import script from "./ProjectBasicInformation.vue?vue&type=script&lang=js&"
export * from "./ProjectBasicInformation.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBasicInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('611891aa')) {
      api.createRecord('611891aa', component.options)
    } else {
      api.reload('611891aa', component.options)
    }
    module.hot.accept("./ProjectBasicInformation.vue?vue&type=template&id=611891aa&", function () {
      api.rerender('611891aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/information/ProjectBasicInformation.vue"
export default component.exports